'use client';
import { sendGTMEvent } from '@next/third-parties/google';
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

export const GooglePageView = () => {
  const pathname = usePathname();

  useEffect(() => {
    sendGTMEvent({
      event: 'pageview',
      pageUrl: pathname,
    });
  }, [pathname]);

  return null;
};
